// extracted by mini-css-extract-plugin
export default {"Footer":"layout_Footer__2mukj","Content":"layout_Content__w5iah","Logo":"layout_Logo__1umYy"};